// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2edjj","name":"Header_name__1vE2Y","birthday":"Header_birthday__DcEh_","skeleton":"Header_skeleton__28-NR"};